import DaumPostcodeEmbed from "react-daum-postcode";
import styled from "styled-components";

const PostCodeModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${(props) =>
    props.isCheckout ? `` : `rgba(0, 0, 0, 0.8)`};
  z-index: 100000008;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-section {
    min-width: 40%;
    background-color: white;
    border-radius: 20px;
    overflow: hidden;
    @media (max-width: 991px) {
      width: 60%;
      overflow: auto;
    }
    @media (max-width: 767px) {
      width: 90%;
      overflow: auto;
    }
  }

  .modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const PostCode = (props) => {
  return (
    <>
      <PostCodeModal
        onClick={props?.onClickHandleModal}
        isCheckout={props.isCheckout}
      >
        <div className="modal-section">
          <div className="modal-content">
            <DaumPostcodeEmbed
              style={{ height: "470px" }}
              onComplete={props?.onCompletePostCode}
            />
          </div>
        </div>
      </PostCodeModal>
    </>
  );
};
export default PostCode;
